import ReportTypes from "../types/ReportTypes"
import HRRService from "./HRRService"
import reports from "./reports"

const HRRSortService = {
    sortReportsByOrder: () => {
        let sorted: ReportTypes[] = []
        for (let i = 0; i < reports.length; i++) {
            let report = reports[i]
            //@ts-ignore
            sorted.push(report.properties.items.sort((a, b) => a.order - b.order))
        }
        return sorted
    },
    sortReportsByKey: (key: string, direction: "ASC" | "DESC") => {
        const { state, manageState } = HRRService
        const sorted = state.employeeReport.sort((a, b) => {
            if (a[key] < b[key]) return direction === "ASC" ? -1 : 1
            if (a[key] > b[key]) return direction === "ASC" ? 1 : -1
            return 0
        })
        manageState([
            { key: "employeeReport", value: sorted },
            { key: "sortOptions", value: { key: key, direction: direction } }
        ])
    }
}

export default HRRSortService